import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-html-viewer',
  templateUrl: './html-viewer.component.html',
  styleUrls: ['./html-viewer.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtmlViewerComponent implements OnInit {

  @Input() html: string;

  constructor(
    private readonly domSanitizer: DomSanitizer,
  ) {
  }

  ngOnInit(): void {
  }

  sanitize(): SafeHtml {
    if (!this.html) {
      return '';
    }
    let html = this.html;
    if (!RegExp.prototype.test.bind(/(<([^>]+)>)/i)(html)) {
      html = `<p>${html}</p>`;
    }
    return this.domSanitizer.bypassSecurityTrustHtml(html);
  }

}
